var Permission;
(function (Permission) {
    Permission[Permission["None"] = 0] = "None";
    Permission[Permission["Ack"] = 1] = "Ack";
    Permission[Permission["Read"] = 2] = "Read";
    Permission[Permission["Write"] = 4] = "Write";
    Permission[Permission["Delete"] = 8] = "Delete";
    Permission[Permission["Share"] = 16] = "Share";
    Permission[Permission["Rename"] = 32] = "Rename";
    Permission[Permission["Move"] = 64] = "Move";
    Permission[Permission["Discard"] = 128] = "Discard";
    Permission[Permission["Restore"] = 256] = "Restore";
    Permission[Permission["Duplicate"] = 512] = "Duplicate";
    Permission[Permission["ReadAppMetadata"] = 1024] = "ReadAppMetadata";
    Permission[Permission["WriteComment"] = 2048] = "WriteComment";
})(Permission || (Permission = {}));
export { Permission };
